import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const headingStyle = {
    fontSize: pxToRem(36),
    lineHeight: pxToRem(43.2),
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontWeight: '700',
    letterSpacing: pxToRem(3.6),
    paddingTop: pxToRem(30),
    paddingBottom: pxToRem(15),
    marginTop: [pxToRem(10), pxToRem(10), '0px', '0px'],
    marginBottom: [pxToRem(10), pxToRem(10), pxToRem(14), pxToRem(14)],
    color: 'blackAlpha.950'
}

export const contentStyle = {
    h3: {
        fontSize: pxToRem(28),
        marginTop: pxToRem(30),
        marginBottom: '0px',
        textAlign: 'center',
        fontWeight: '500',
        fontFamily: fonts.primary,
        letterSpacing: pxToRem(1),
        lineHeight: [pxToRem(33.6), pxToRem(33.6), pxToRem(18), pxToRem(18)],
        textTransform: 'capitalize',
        color: 'blackAlpha.950'
    },
    '.purchase-txt': {
        fontSize: pxToRem(14),
        lineHeight: pxToRem(23.8),
        textAlign: 'center',
        margin: `${pxToRem(30)} 0`,
        fontWeight: '500',
        fontFamily: fonts.primary,
        letterSpacing: pxToRem(1),
        color: 'blackAlpha.950'
    },
    '.faq-btn': {
        textAlign: 'center',
        marginBottom: [pxToRem(30), pxToRem(30), pxToRem(120), pxToRem(120)],
        button: {
            backgroundColor: 'cav_dark_red',
            borderRadius: '0px',
            color: 'white',
            fontSize: pxToRem(14),
            fontWeight: '700',
            fontFamily: fonts.primary,
            padding: `${pxToRem(12.6)} ${pxToRem(42)}`,
            textTransform: 'uppercase',
            letterSpacing: pxToRem(1),
            lineHeight: pxToRem(18),
            minHeight: pxToRem(44),
            [`@media (max-width: ${sizes.container.md})`]: {
                padding: `${pxToRem(12.6)} ${pxToRem(26.6)}`
            }
        }
    }
}

export const physicalGiftCardWrapper = {
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row']
}

export const physicalCardStyle = {
    '.gift-type-container': {
        display: 'flex',
        flexDirection: ['column', 'column', 'row', 'row'],
        marginBottom: ['0px', '0px', pxToRem(70), pxToRem(70)],
        '.gift-type-img': {
            width: ['100%', '100%', pxToRem(267), pxToRem(267)],
            height: ['auto', 'auto', pxToRem(188), pxToRem(188)],
            marginTop: [pxToRem(10), pxToRem(10), '0px', '0px'],
            marginBottom: [pxToRem(10), pxToRem(10), '0px', '0px']
        },
        '.gift-type-details': {
            padding: `0 ${pxToRem(10)} 0 ${pxToRem(10)}`,
            lineHeight: pxToRem(18),
            width: ['100%', '100%', '45%', '45%'],
            [`@media (max-width: ${sizes.container.md})`]: {
                padding: '0px'
            },
            '.gift-type-title': {
                textTransform: 'uppercase',
                fontSize: pxToRem(18),
                lineHeight: pxToRem(21.6),
                fontWeight: '700',
                letterSpacing: pxToRem(1.8),
                fontFamily: fonts.primary,
                color: 'blackAlpha.950'
            },
            p: {
                fontSize: pxToRem(14),
                fontWeight: '500',
                margin: `${pxToRem(14)} 0`,
                letterSpacing: pxToRem(1),
                lineHeight: pxToRem(24),
                fontFamily: fonts.primary,
                color: 'blackAlpha.950'
            },
            button: {
                backgroundColor: 'cav_dark_red',
                borderRadius: '0px',
                color: 'white',
                fontSize: pxToRem(14),
                fontWeight: '700',
                fontFamily: fonts.primary,
                padding: `${pxToRem(12.6)} ${pxToRem(42)}`,
                textTransform: 'uppercase',
                letterSpacing: pxToRem(1),
                width: '100%',
                lineHeight: pxToRem(18)
            }
        }
    }
}

export const giftBalanceStyle = {
    '.gift-balance-txt': {
        '.gift-check-title': {
            textTransform: 'uppercase',
            fontSize: pxToRem(18),
            lineHeight: pxToRem(21.6),
            fontWeight: '700',
            fontFamily: fonts.primary,
            letterSpacing: pxToRem(1.8),
            color: 'blackAlpha.950'
        },
        p: {
            fontWeight: '500',
            fontSize: pxToRem(14),
            lineHeight: pxToRem(24),
            fontFamily: fonts.primary,
            margin: `${pxToRem(14)} 0`,
            letterSpacing: pxToRem(1),
            color: 'blackAlpha.950'
        }
    }
}
